const proj4 = require('proj4').default;
// Madrid
const COORDINATES_MADRID_3857 = [-408123.88498523977, 4926977.669227466];
// Map raster
const PROJECTION_25830 = '+proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs';
// Map tiles
const PROJECTION_3857 = '+proj=merc + a=6378137 + b=6378137 + lat_ts=0.0 + lon_0=0.0 + ' +
    'x_0=0.0 + y_0=0 + k=1.0 + units=m + nadgrids=@null +wktext +no_defs';
// UI
const PROJECTION_4326 = '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs';
const EXTENT_VIEW_BBOX_3857 = [
  -6281216.742308266,
  -87765.04114339128,
  6337352.786436159,
  10715604.230565874,
];
const EXTENT_VIEW_BBOX_25830 = [
  -5038617.686840486,
  1050806.598628521,
  4566879.673729379,
  6603804.872997118,
];

// const convertProjection25830to3857 = proj4(PROJECTION_25830, PROJECTION_3857);

// function convertCoordinates(coordinateX, coordinateY,
//   convertProjection = convertProjection25830to3857) {
//   if (!!coordinateX && !!coordinateY) {
//     const coordOrig = [coordinateX, coordinateY];
//     return convertProjection.forward(coordOrig);
//   }
//   return [];
// }

function convertCoordinates(coordinateX, coordinateY, convertProjection = null) {
  if (coordinateX != null && coordinateY != null) {
    // como ya están en 3857, no llamamos a ninguna transformación
    return [coordinateX, coordinateY];
  }
  return [];
}

export {
  proj4,
  COORDINATES_MADRID_3857,
  PROJECTION_3857,
  PROJECTION_25830,
  PROJECTION_4326,
  EXTENT_VIEW_BBOX_3857,
  EXTENT_VIEW_BBOX_25830,
  convertCoordinates,
};
